import React, { useEffect, useState } from "react";
import { CustomTabPanel } from "../../../components/tabComponent";
import SimpleTable from "../../../components/tables/simpleTable";
import { icons } from "../../../constants";
import { Grid, useMediaQuery } from "@mui/material";
import {
  callApiAsync,
  getInterestedPartiesProcessDashboard,
  getStakeholdersByTypeId
} from "../../../services/apiService";
import { useNavigate } from "react-router-dom";
import { stakeholdersTabType } from "../../../constants/enums";
import { formatCustomDateName } from "../../../utils/dateUtils";
import DateBanners from "../dateBanners";

const countCell = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? String(n) : "";
};

const InterestedPartiesProcessTab = () => {
  const navigate = useNavigate();

  const [process, setProcess] = useState([]);
  const [open, setOpen] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [updateDate, setUpdateDate] = useState(null);
  const [selectedObject, setSelectedObject] = useState(null);
  const [openVerification, setOpenVerification] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "success",
    summary: "",
    detail: ""
  });

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const columnsInterestedPartiesProcess = [
    { field: "name", header: "Proceso al que pertenece" },
    {
      field: "internal",
      header: "Partes interesadas internas",
      columnType: "custom",
      render: (row) => (
        <div className="table-column-container">
          <p className="table-default-column" style={{ textAlign: "right" }}>
            {countCell(row.internal)}
          </p>
        </div>
      )
    },
    {
      field: "external",
      header: "Partes interesadas externas",
      columnType: "custom",
      render: (row) => (
        <div className="table-column-container">
          <p className="table-default-column" style={{ textAlign: "right" }}>
            {countCell(row.external)}
          </p>
        </div>
      )
    },
    {
      field: "total",
      header: "Total",
      columnType: "custom",
      render: (row) => (
        <div className="table-column-container">
          <p className="table-default-column" style={{ textAlign: "right" }}>
            {countCell(row.total)}
          </p>
        </div>
      )
    },
    { field: "actions", header: "", columnType: "actionButtons" }
  ];

  const loadDashboardProcesses = async () => {
    await callApiAsync(
      () => getInterestedPartiesProcessDashboard(),
      (data) => {
        setProcess(data);
      }
    );
  };

  const getStakeholderUpdateDate = async () => {
    await callApiAsync(
      () => getStakeholdersByTypeId(stakeholdersTabType.byProcess),
      (data) => {
        setUpdateDate(data.update_date);
      }
    );
  };

  useEffect(() => {
    loadDashboardProcesses();
    getStakeholderUpdateDate();
  }, []);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <div
            className={
              isMediumScreen ? "mb-10" : isSmallScreen ? "mb-10" : "mr-10"
            }
          ></div>
        </Grid>
      </Grid>

      <SimpleTable
        data={process}
        tableStyle={{ minWidth: "870px" }}
        columns={columnsInterestedPartiesProcess}
        buttons={[
          {
            type: "icon",
            icon: icons.stakeholders,
            iconSize: "35px",
            onClick: (data) => {
              navigate(`/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail`, {
                state: { rowData: data }
              });
            }
          }
        ]}
        isPaginated={true}
      />
    </div>
  );
};

export default InterestedPartiesProcessTab;
